import axios from "axios";
import {
    LOGIN_ROUTE,
    PROFILE_ROUTE,
    CHANGEPASSWORD_ROUTE,
    LOGOUT_ROUTE,
    DASHBOARDSTATS_ROUTE,
    GET_ALL_GAMES_ROUTE,
    CREATE_GAME_ROUTE,
    UPDATE_GAME_ROUTE,
    DELETE_GAME_ROUTE,
    GET_ALL_TRANSACTIONS_ROUTE,
    GET_TRANSACTION_DETAILS_ROUTE,
    GET_SESSIONS_ROUTE,
    GET_SESSION_DELETE_ROUTE,
    GET_ALL_SOCIAL_ROUTE,
    CREATE_SOCIAL_ROUTE,
    UPDATE_SOCIAL_ROUTE,
    TOGGLE_SOCIAL_ROUTE,
    DELETE_SOCIAL_ROUTE,
} from "./apiRoutes";

export const login = async (payload) => {
    try {
        const response = await axios.post(LOGIN_ROUTE, payload, {
            headers: {
                "Content-Type": "application/json",
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Login error:", error);
        throw error;
    }
};

export const fetchProfile = async (token) => {
    if (!token) {
        throw new Error("No token provided");
    }
    try {
        const response = await axios.get(PROFILE_ROUTE, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Profile fetch error:", error);
        throw error;
    }
};

export const changePassword = async (token, payload) => {
    try {
        const response = await axios.put(CHANGEPASSWORD_ROUTE, payload, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Change password error:", error);
        throw error;
    }
};

export const logout = async () => {
    try {
        const response = await axios.post(LOGOUT_ROUTE, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Logout error:", error);
        throw error;
    }
};


export const fetchDashboardStats = async (token, period = '') => {
    try {
        const url = period ? `${DASHBOARDSTATS_ROUTE}?period=${period}` : DASHBOARDSTATS_ROUTE;
        const response = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Dashboard stats fetch error:", error);
        throw error;
    }
};

export const fetchAllGames = async (token) => {
    try {
        const response = await axios.get(GET_ALL_GAMES_ROUTE, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Fetch all games error:", error);
        throw error;
    }
};

export const createGame = async (token, payload) => {
    try {
        const response = await axios.post(CREATE_GAME_ROUTE, payload, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Create game error:", error);
        throw error;
    }
};

export const updateGame = async (token, game_id, payload) => {
    try {
        const response = await axios.put(UPDATE_GAME_ROUTE(game_id), payload, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Update game error:", error);
        throw error;
    }
};

export const deleteGame = async (token, game_id) => {
    try {
        const response = await axios.delete(DELETE_GAME_ROUTE(game_id), {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Delete game error:", error);
        throw error;
    }
};

export const fetchAllTransactions = async (token, page = 1, limit = 20, status = '', search = '', period = '') => {
    try {
        const params = new URLSearchParams({ page, limit });
        if (status) params.append('status', status);
        if (search) params.append('search', search);
        if (period) params.append('period', period);
        const response = await axios.get(`${GET_ALL_TRANSACTIONS_ROUTE}?${params}`, {
            headers: { 
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any"
            }
        });
        return response.data;
    } catch (error) {
        console.error("Fetch all transactions error:", error);
        throw error;
    }
};

export const fetchTransactionDetails = async (token, transaction_id) => {
    try {
        const response = await axios.get(GET_TRANSACTION_DETAILS_ROUTE(transaction_id), {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    }
    catch (error) {
        console.error("Fetch transaction details error:", error);
        throw error;
    }
};

export const fetchSessions = async (token, page = 1, limit = 20, status = '', search = '', period = '') => {
    try {
        const params = new URLSearchParams({ page, limit });
        if (status) params.append('status', status);
        if (search) params.append('search', search);
        if (period) params.append('period', period);
        const response = await axios.get(`${GET_SESSIONS_ROUTE}?${params}`, {
            headers: { 
                "Content-Type": "application/json", 
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any"
            }
        });
        return response.data;
    } catch (error) {
        console.error("Fetch sessions error:", error);
        throw error;
    }
};

export const deleteSession = async (token, session_id) => {
    try {
        const response = await axios.delete(GET_SESSION_DELETE_ROUTE(session_id), {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any",
            }
        });
        return response.data;
    } catch (error) {
        console.error("Delete session error:", error);
        throw error;
    }
};

// ─── Social Media ─────────────────────────────────────────────────────────────

export const fetchAllSocialLinks = async (token) => {
    try {
        const response = await axios.get(GET_ALL_SOCIAL_ROUTE, {
            headers: { 
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any"
            }
        });
        return response.data;
    } catch (error) {
        console.error("Fetch social links error:", error);
        throw error;
    }
};

export const createSocialLink = async (token, payload) => {
    try {
        const response = await axios.post(CREATE_SOCIAL_ROUTE, payload, {
            headers: { 
                "Content-Type": "application/json", 
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any"
            }
        });
        return response.data;
    } catch (error) {
        console.error("Create social link error:", error);
        throw error;
    }
};

export const updateSocialLink = async (token, id, payload) => {
    try {
        const response = await axios.put(UPDATE_SOCIAL_ROUTE(id), payload, {
            headers: { 
                "Content-Type": "application/json", 
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any"
            }
        });
        return response.data;
    } catch (error) {
        console.error("Update social link error:", error);
        throw error;
    }
};

export const toggleSocialLink = async (token, id) => {
    try {
        const response = await axios.patch(TOGGLE_SOCIAL_ROUTE(id), {}, {
            headers: { 
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any"
            }
        });
        return response.data;
    } catch (error) {
        console.error("Toggle social link error:", error);
        throw error;
    }
};

export const deleteSocialLink = async (token, id) => {
    try {
        const response = await axios.delete(DELETE_SOCIAL_ROUTE(id), {
            headers: { 
                "Authorization": `Bearer ${token}`,
                "ngrok-skip-browser-warning": "any"
            }
        });
        return response.data;
    } catch (error) {
        console.error("Delete social link error:", error);
        throw error;
    }
};